/**
 * CallDispositionBar — the "Next steps" surface inside Call Mode: schedule a
 * callback, create a follow-up task, and send a form, all without leaving the
 * call. Reuses the existing rail cards unchanged (each owns its own endpoints and
 * refetches on reloadToken). The lead-status quick-set lives in the workspace
 * header (LifecycleSelect), so it's not duplicated here.
 */
import { Contact } from '../../types';
import CallbacksCard from '../CallbacksCard';
import TasksCard from '../TasksCard';
import SendFormCard from '../SendFormCard';

interface Props {
  contact: Contact;
  maxAttempts?: number;
  reloadToken?: number;
  onSent?: () => void;
}

export default function CallDispositionBar({ contact, maxAttempts, reloadToken, onSent }: Props) {
  return (
    <div className="space-y-4">
      <CallbacksCard contact={contact} maxAttempts={maxAttempts} reloadToken={reloadToken} onSent={onSent} />
      <TasksCard contactId={contact.id} />
      <SendFormCard contact={contact} reloadToken={reloadToken} onSent={onSent} />
    </div>
  );
}
